<template>
    <div>
        <div class="bg-gray-50 border-gray-200 border-b border-t">
            <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
                <div class="flex-shrink-0 group block">
                    <div class="flex items-center">
                        <div :class="`text-${$root.theme}-800`">
                            <svg class="inline-block h-10 w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <div class="ml-3">
                            <p :class="`pt-1 font-semibold text-lg text-${$root.theme}-500 group-hover:text-${$root.theme}-600`">
                                Payment Schedule
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-gray-200 border-b">
            <div class="p-5 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">

                <div class="overflow-y-auto max-h-96 p-4 mb-4 border-2 border-gray-200 rounded-lg text-sm" v-html="template" />

                <div class="flex flex-col md:flex-row-reverse justify-between space-y-2 md:space-y-0">
                    <button type="button"
                            @click="accept"
                            :class="{[
                        `text-white px-3 text-xs py-2 md:ml-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:ring-${$root.theme}-200`]: true
                    }">
                        I agree
                    </button>
                    <i v-show="loading" :class="`fa fa-spinner fa-spin text-${$root.theme}-300 fa-2x`"></i>
                    <button type="button"
                            @click="$emit('canceled')"
                            :class="{[`text-black px-3 text-xs py-2 md:mr-1 border border-transparent shadow-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-gray-300 hover:bg-gray-400 focus:ring-gray-200`]: true}">
                        {{ cancelText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixins from "../mixins";

    export default {
        mixins: [Mixins],

        props: {
            accountId: {},
            template: {},
            transactions: {},
            cancelText: {
                type: String,
                default: 'Go Back'
            }
        },

        data() {
            return {
                loading: false
            }
        },

        mounted() {
            this.gtagEvent('payment-authorization-requested');

            this.$root.$refs.app.updatePageName('obtain-payment-authorization');
        },

        methods: {
            accept() {
                if (this.loading) return;

                this.loading = true;

                this.gtagEvent('payment-authorization-accepted');

                setTimeout(() => this.$emit('accepted'), 1000);
            }
        }
    }
</script>
